import { forwardRef } from 'react';
import { isString } from 'lodash-es';
import classNames from 'classnames';

import { BaseButtonProps, NewBaseButton } from '@shared/components/base/NewBaseButton';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';
import styles from './index.module.less';
import { loading2 } from '@shared/assets/svg/base';

/** height: nano-28 mini-32 small-36 medium-40 large-44 huge-48  */
export type BaseIconButtonProps = {
	icon: React.ReactNode;
	iconSize?: number;
	loading?: boolean;
	iconColor?: string;
	iconClassName?: string;
	position?: 'left' | 'right';
  extraProps?: any;
} & Omit<BaseButtonProps, 'loading'>;

export const BaseIconButton = forwardRef<HTMLButtonElement, BaseIconButtonProps>(
	(props: BaseIconButtonProps, ref) => {
		const {
			children,
			icon,
			innerClassName,
			position = 'left',
			iconSize,
			loading,
			className,
			iconColor,
			size = 'medium',
			iconClassName,
      extraProps,
			...restProps
		} = props;

		const defaultIconSize = ['nano', 'mini', 'small'].includes(size) ? 16 : 20;

		const renderChildren = isString(children) ? <span>{children}</span> : children;

		const renderLoadingIcon = (
			<NewBaseIcon
				icon={loading2}
				size={['nano', 'mini', 'small'].includes(size) ? 16 : 20}
				className={styles.loading_animation}
			/>
		);
		return (
			<NewBaseButton
				ref={ref}
				className={classNames([styles.outer], [className])}
				innerClassName={classNames(innerClassName, {
					[styles[`size_${size}`]]: !children,
				})}
				loading={false}
        disabled={loading || extraProps?.disabled}
				size={size}
				{...restProps}
			>
				{position === 'left' &&
					(loading ? (
						renderLoadingIcon
					) : (
						<NewBaseIcon
							className={iconClassName}
							icon={icon}
							size={iconSize || defaultIconSize}
							color={iconColor}
						/>
					))}
				{renderChildren}
				{position === 'right' &&
					(loading ? (
						renderLoadingIcon
					) : (
						<NewBaseIcon
							className={iconClassName}
							icon={icon}
							size={iconSize || defaultIconSize}
							color={iconColor}
						/>
					))}
			</NewBaseButton>
		);
	},
);
